import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ListItemCardCst from "@components/ListItemCardCst";
import { useCardActions } from "@hooks/useCardActions";
import { mapUserToCard } from "../mapUserToCard";

export interface UserItemHandlers {
  onEnroll: (user: any) => void;
  onViewLO: (user: any) => void;
  onDownloadCsv: (user: any) => void;
  onImpersonate: (user: any) => void;
  onEdit: (user: any) => void;
  onBlock: (user: any) => void;
  onDelete: (user: any) => void;
}

interface UserItemProps extends UserItemHandlers {
  user: any;
  corporateId?: string;
  selectable?: boolean;
  selected?: boolean;
  onSelect?: (next: boolean) => void;
  onOpenDetail?: (user: any) => void;
}

const UserItem: React.FC<UserItemProps> = ({
  user,
  corporateId,
  selectable = true,
  selected = false,
  onSelect,
  onEnroll,
  onViewLO,
  onDownloadCsv,
  onImpersonate,
  onEdit,
  onBlock,
  onDelete,
  onOpenDetail,
}) => {
  const overrides = useMemo(
    () => ({
      enroll: () => onEnroll(user),
      "view-lo": () => onViewLO(user),
      "download-csv": () => onDownloadCsv(user),
      impersonate: () => onImpersonate(user),
      edit: () => onEdit(user),
      block: () => onBlock(user),
      delete: () => onDelete(user),
    }),
    [
      user,
      onEnroll,
      onViewLO,
      onDownloadCsv,
      onImpersonate,
      onEdit,
      onBlock,
      onDelete,
    ],
  );

  const moreActions = useCardActions("user", user, { corporateId, overrides });

  const { t: tInput } = useTranslation("input");
  const { t: tCard } = useTranslation("list-item-card");

  const cardProps = mapUserToCard(user, { tInput, corporateId });

  const actions = onOpenDetail
    ? [
        {
          label: tCard("actions.details"),
          variant: "outlined" as const,
          onClick: () => onOpenDetail(user),
        },
      ]
    : undefined;

  return (
    <ListItemCardCst
      {...cardProps}
      selectable={selectable}
      selected={selected}
      onSelect={onSelect}
      actions={actions}
      moreActions={moreActions}
    />
  );
};

export default UserItem;
